import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AssistanceTypes } from '@/help.search';
let AssistanceType = class AssistanceType extends Vue {
    //really this is/should be AssistanceTypes but vue-property-decorator/vue itself is being shit an passing it as string
    get asEnum() {
        return AssistanceTypes[this.data];
    }
    get title() {
        return `Assistance with ${this.data}`;
    }
    get iconClass() {
        if (this.asEnum === AssistanceTypes.Charging)
            return "fad fa-battery-bolt";
        else if (this.asEnum === AssistanceTypes.Payment)
            return "fad fa-money-check";
        else
            throw new Error(`${this.data} is not a valid value of AssistanceTypes`);
    }
};
tslib_1.__decorate([
    Prop()
], AssistanceType.prototype, "data", void 0);
AssistanceType = tslib_1.__decorate([
    Component
], AssistanceType);
export default AssistanceType;
